import { NgModule } from '@angular/core';

import { CHECKOUT_CORE_FEATURE, CheckoutRootModule } from '@spartacus/checkout/base/root';
import { provideConfig } from '@spartacus/core';

@NgModule({
  imports: [
    CheckoutRootModule
  ],
  providers: [
    provideConfig({
      featureModules: {
        [CHECKOUT_CORE_FEATURE]: {
          module: () => import('@spartacus/checkout/base/core').then((m) => m.CheckoutCoreModule),
          dependencies: [() => import('@spartacus/checkout/base/occ').then((m) => m.CheckoutOccModule)]
        }
      }
    })
  ]
})
export class CheckoutFeatureModule {}
